CheckItem = require 'app/scripts/models/check-item'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'

class CheckItemList extends CollectionWithHelpers
  model: CheckItem
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (checkItem) -> checkItem.get('pos')

module.exports = CheckItemList
